import { createFileRoute } from '@tanstack/react-router';

import { TailoredSupplyListPage } from '../features/supply/tailored-supply/TailoredSupplyListPage';
import { tailoredSupplyListRouteSearchSchema } from '../features/supply/tailored-supply/routeSearch';

export const Route = createFileRoute('/supply/tailored-supply/')({
  validateSearch: tailoredSupplyListRouteSearchSchema,
  component: TailoredSupplyListPage,
});
